import { FinancialServiceProviderAdapters } from '@seapoint/server/enums';
import { AccountView } from '../../types/entity-types';

/**
 * Gets the category priority for sorting accounts.
 * Lower numbers appear first.
 * 1 = Modulr Account (Seapoint)
 * 2 = Treasury Account (Seapoint)
 * 3 = Open Banking Accounts
 * 4 = Other accounts (fallback)
 */
const getAccountCategoryPriority = (account: AccountView): number => {
  const adapter = account.fspAdapter;

  if (adapter === FinancialServiceProviderAdapters.MODULR) {
    return 1;
  }
  if (adapter === FinancialServiceProviderAdapters.WEALTHKERNEL) {
    return 2;
  }
  if (adapter === FinancialServiceProviderAdapters.GOCARDLESS || adapter === FinancialServiceProviderAdapters.YAPILY) {
    return 3;
  }
  return 4;
};

/**
 * Sorts accounts by category (Modulr, Treasury, Open Banking) and then by balance (descending).
 * Within each category, accounts are sorted by balance in descending order.
 *
 * Order:
 * 1. Modulr Account (Seapoint) - sorted by balance descending
 * 2. Treasury Account (Seapoint) - sorted by balance descending
 * 3. Open Banking Accounts - sorted by balance descending
 * 4. Other accounts - sorted by balance descending
 */
export const sortAccountsByCategoryAndBalance = (accounts: AccountView[]): void => {
  accounts.sort((a, b) => {
    // First, sort by category priority
    const categoryA = getAccountCategoryPriority(a);
    const categoryB = getAccountCategoryPriority(b);

    if (categoryA !== categoryB) {
      return categoryA - categoryB;
    }

    // Within the same category, sort by balance (descending)
    const balanceA = a.totalBalance ?? 0;
    const balanceB = b.totalBalance ?? 0;

    return balanceB - balanceA;
  });
};
